/**
 * Source for platform ID info
 * @module
 */

var UAParser = require('core/utils/ua_parser');

/**
 *
 * @returns {string}
 */
exports.getPlatform = function(): string {
  return UAParser.get().platform;
};
